export const getCartData = (cartData) => {
  return {
    type: 'getCart',
    payload: cartData,
  }
}

export const createCart = (data) => {
  return {
    type: 'createCart',
    payload: data,
  }
}

export const updateCartData = (cartData) => {
  return {
    type: 'updateCart',
    payload: cartData,
  }
}
